import { render, staticRenderFns } from "./StorageBuckets.vue?vue&type=template&id=22f5ea88&scoped=true"
import script from "./StorageBuckets.vue?vue&type=script&lang=js"
export * from "./StorageBuckets.vue?vue&type=script&lang=js"
import style0 from "./StorageBuckets.vue?vue&type=style&index=0&id=22f5ea88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f5ea88",
  null
  
)

export default component.exports